<script setup lang="ts">
  import { type RepairLocation } from 'src/composables/repairFinder';
  import RepairCard from './RepairCard.vue';
  import RepairCardSkeleton from './RepairCardSkeleton.vue';
  import WidgetIcon from 'src/components/base/WidgetIcon.vue';
  import { themeIcons } from 'src/utils/config';

  const props = defineProps<{
    repairLocations: RepairLocation[];
    loading?: boolean;
    isLiability?: boolean;
  }>();
  const emit = defineEmits<{
    save: [location: RepairLocation];
    fullInfo: [];
  }>();
</script>

<template>
  <div class="flex flex-col overflow-y-auto">
    <template v-if="props.repairLocations && props.repairLocations.length">
      <div
        v-for="(location, index) in props.repairLocations"
        :key="location.id || index"
        :class="{ 'mb-4': index !== props.repairLocations?.length - 1 }"
      >
        <RepairCard :location="location" @save="emit('save', $event)" />
      </div>
    </template>
    <template v-else-if="loading">
      <RepairCardSkeleton v-for="n in 10" :key="n" :class="{ 'mb-4': n !== 9 }"> </RepairCardSkeleton>
    </template>
    <template v-else>
      <slot name="noResults">
        <div class="body1 flex flex-col items-center justify-center p-4 text-center">
          <WidgetIcon :icon="themeIcons.noResult" class="size-48 text-primary"></WidgetIcon>
          <p>No results.</p>
        </div>
      </slot>
    </template>
  </div>
</template>
